import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import ActionItem from 'Shared/components/ActionItem/ActionItem';
import { unixDateMMMDDYYYY } from 'Shared/utils/DateTime.utils';
import { getMeetingItemByUuid } from 'Shared/selectors/common';

import DiscussionTopic from 'Shared/components/DiscussionTopic/DiscussionTopic';

import './CompletedItem.scss';

type Props = {
  uuid: string;
  withWorkspaceSection?: boolean;
  isFocused?: boolean;
};

const getCompletedComponent = {
  discussion_topic: DiscussionTopic,
  action_item: ActionItem,
};

function CompletedItem({ uuid, withWorkspaceSection, isFocused }: Props) {
  const { completedAt, itemType, completed } = useSelector(getMeetingItemByUuid(uuid));

  const CompletedComponent = getCompletedComponent[itemType];

  return (
    <div className="completed-item d-flex flex-column mb-2">
      <div className={cn('border', { 'completed-item-body--colored': isFocused, 'completed-item-body': completed })}>
        <CompletedComponent
          isDisabled
          forbidDrag
          uuid={uuid}
          withWorkspaceSection={withWorkspaceSection}
          withDueDateSection
          withOwnerSection
          isFocused={isFocused}
        />
      </div>
      <div className="completed-item-date align-self-end">
        {completedAt ? (
          <div>
            Completed &nbsp;
            {unixDateMMMDDYYYY(completedAt)}
          </div>
        ) : (
          <div className="mb-3" />
        )}
      </div>
    </div>
  );
}

export default memo(CompletedItem);
